/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@compiled/react';

import { SkeletonItem } from '@atlaskit/menu';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	skeletonItem: {
		// This is a workaround to increase the size of the avatar in the skeleton item.
		// These styles are considered unsafe and may break with future releases of @atlaskit/menu.
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'> div::before': {
			marginInlineStart: token('space.0', '0px'),
			marginInlineEnd: token('space.150', '12px'),
			width: '32px',
			height: '32px',
		},
	},
});

export default function LoadingSkeletonItem() {
	return (
		<div css={styles.skeletonItem}>
			<SkeletonItem hasAvatar testId="people-menu-skeleton-item" />
		</div>
	);
}
